module.exports = __webpack_public_path__ + "img/portfolio.818e5d86.svg";